/* eslint-disable react/require-default-props */
import * as React from 'react';
import {TextStyle, View, ViewStyle} from 'react-native';

import {styles} from './FormattedNumber.style';
import InlineFormattedNumber from './InlineFormattedNumber';

interface FormattedNumberStyle {
  base?: ViewStyle;
  text?: TextStyle;
}

interface FormattedNumberProps {
  testID?: string | null;
  value?: any;
  style?: FormattedNumberStyle;
  truncate?: boolean;
  boldText?: boolean;
  textVariant?: string;
  textEmphasis?: string;
  accessible?: boolean;
  currencyCode?: string | null;
  decimalPlaces?: number;
  decimalSymbol?: string;
  separator?: string;
  separationStyle?: string;
  preserveNegative?: boolean;
}
export const FormattedNumber: React.FC<FormattedNumberProps> = ({
  style = {},
  accessible,
  ...props
}) => {
  const containerStyle = [styles.base, style.base];
  return (
    <View style={containerStyle} accessible={accessible}>
      <InlineFormattedNumber {...props} style={style.text} />
    </View>
  );
};

export default FormattedNumber;
